/*
*	Rotator delay
*/
export default function (_rotator, _delay, _between)
{
	var _rd = this;
	_rd.rotator = _rotator;
	_rd.delay = _delay;
	_rd.between = _between;
	_rd.intervals = {
		slides: undefined,
		between: undefined
	};
	_rd.el = {
		progress_bar : _rd.rotator.$el.find(".banner__progress")
	};
	_rd.status = {
		isPaused: false,
		isReached: false,
		startTime: undefined
	};
	
	_rd.tick = function()
	{
		if (!_rd.status.isPaused && !_rd.status.isReached){
			var percent = ((new Date()).getTime() - _rd.status.startTime) / _rd.delay * 100;
			_rd.el.progress_bar.css("width", percent + "%");
			if ('requestAnimationFrame' in window) {
				requestAnimationFrame(_rd.tick);
			} else {
				setTimeout(function() {
					_rd.tick();
				}, 1000/60);
			}
		}
	};

	_rd.startInterval = function()
	{
		_rd.status.isPaused = false;
		_rd.status.isReached = false;
		clearTimeout(_rd.intervals.slide);
		_rd.intervals.slide = setTimeout(function(){
			_rd.status.isReached = true;
		}, _rd.delay);
		_rd.status.startTime = (new Date()).getTime();
		if ('requestAnimationFrame' in window) {
			requestAnimationFrame(_rd.tick);
		} else {
			setTimeout(function() {
				_rd.tick();
			}, 1000/60);
		}
	};

	_rd.stop = function()
	{
		_rd.status.isPaused = true;
		clearInterval(_rd.intervals.slide);
		clearInterval(_rd.intervals.between);
	};

	return function()
	{
		_rd.rotator.on("slideChange", function(){
			_rd.intervals.between = setTimeout(function(){
				_rd.startInterval();
			}, _rd.between);
		});
		_rd.rotator.on("touchEnd", function(){
			if (_rd.status.isPaused){
				_rd.intervals.between = setTimeout(function(){
					_rd.startInterval();
				}, _rd.between);
				_rd.status.isPaused = false;
			}
		});
		_rd.rotator.on("touchMove", function(){
			if (!_rd.status.isPaused){
				_rd.status.isPaused = true;
				_rd.el.progress_bar.css("width", "0%");
				clearInterval(_rd.intervals.slide);
				clearInterval(_rd.intervals.between);
			}
		});
		_rd.startInterval();

		return _rd;
	}();
};
